import MapElement from "./MapElement";

export default class Shape extends MapElement {
    static Type = {
        LINE_STRING: 0,
        MULTI_LINE_STRING: 1,
        POLYGON: 2,
        MULTI_POLYGON: 3
    }

    constructor(id, hidden) {
        super(id, hidden);

        this.topLeftBound = null;
        this.bottomRightBound = null;
        this.shapeType = null;
    }

    getGeoPoints() {
        throw new Error("Method must be overriden in subclass.");
    }

    getBounds() {
        return [this.topLeftBound, this.bottomRightBound];
        // var topLatitude = -90.0;
        // var leftLongitude = 180.0;
        // var bottomLatitude = 90.0;
        // var rightLongitude = -180.0;

        // const geoPoints = this.getGeoPoints();
        // if (geoPoints) {
        //     for (const geoPoint of geoPoints) {
        //         topLatitude = Math.max(topLatitude, geoPoint.latitude);
        //         leftLongitude = Math.min(leftLongitude, geoPoint.longitude);
        //         bottomLatitude = Math.min(bottomLatitude, geoPoint.latitude);
        //         rightLongitude = Math.max(rightLongitude, geoPoint.longitude);
        //     }

        //     const topLeftBound = new Location(topLatitude, leftLongitude);
        //     const bottomRightBound = new Location(bottomLatitude, rightLongitude);
        //     return [topLeftBound, bottomRightBound];
        // } else {
        //     return [new Location(0, 0), new Location(0, 0)];
        // }
    }
}